'use client';

import Script from 'next/script';
import { usePathname } from 'next/navigation';
import { MARKETING_CONFIG } from '@/lib/marketing-config';

export function GoogleAnalytics() {
  // The signing link carries a secret token in its path; never hand it to a tracker.
  const pathname = usePathname();
  if (pathname?.startsWith('/firmar/')) return null;

  const gaId = MARKETING_CONFIG.analytics.googleAnalyticsId;

  // Don't render if GA ID is not configured
  if (!gaId || gaId === 'G-XXXXXXXXXX') {
    return null;
  }

  return (
    <>
      {/* Google Analytics Script */}
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${gaId}`}
        strategy="afterInteractive"
      />
      <Script id="google-analytics" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${gaId}', {
            page_path: window.location.pathname,
          });
        `}
      </Script>
    </>
  );
}

/**
 * Helper function to track custom events
 * Usage in components:
 *
 * import { trackEvent } from '@/components/analytics/GoogleAnalytics';
 * trackEvent('cta_click', { source: 'hero', tier: 'Pro' });
 */
export function trackEvent(eventName: string, eventParams?: Record<string, any>) {
  if (typeof window !== 'undefined' && (window as any).gtag) {
    (window as any).gtag('event', eventName, eventParams);
  }
}

/**
 * Track page views (for SPA navigation)
 */
export function trackPageView(url: string) {
  if (typeof window !== 'undefined' && (window as any).gtag) {
    (window as any).gtag('config', MARKETING_CONFIG.analytics.googleAnalyticsId, {
      page_path: url,
    });
  }
}
